import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { IconFilter, IconSearch, StyledButton, StyledSearchDesktopComponent } from "@components";
import { theme, useWindowDimensions } from "@utilities";
import { FilterModule } from "@module";
import { AppDispatch, selectSearchCategories, setName, useAppSelector } from "@redux";
import { PATH_SEARCH_RESULT } from "@routes";

interface IProps {
    onChangeIsIncreasePaddingTop: () => void;
}

export const SearchModule = (props: IProps) => {
    const { width } = useWindowDimensions();
    const [isShowFilter, setIsShowFilter] = useState<boolean>(false);
    const searchCategories = useAppSelector(selectSearchCategories);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const nameValue = searchCategories.name ? searchCategories.name : "";
    const redirectPathName = `${PATH_SEARCH_RESULT}?query=${encodeURIComponent(searchCategories.name ?? "")}`;

    const hasAnyFilterSelected = () => {
        const hasName = !!searchCategories.name?.trim();
        const hasAccommodation = (searchCategories.accommodation?.length ?? 0) > 0;
        const hasActivities = (searchCategories.activities?.length ?? 0) > 0;
        const hasSuppliers = (searchCategories.suppliers?.length ?? 0) > 0;
        const hasTransports = (searchCategories.transports?.length ?? 0) > 0;
        const hasDuration = !!searchCategories.duration;

        return hasName || hasAccommodation || hasActivities || hasSuppliers || 
               hasTransports || hasDuration;
    };

    const canSearch = hasAnyFilterSelected();

    const handleToggleShowFilter = () => {
        setIsShowFilter(!isShowFilter);
        props.onChangeIsIncreasePaddingTop();
    };

    const handleSearch = () => {
        if (!canSearch) return;
        navigate(redirectPathName);
    };

    const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setName(e.target.value));
    };

    const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === 13 && canSearch) {
            navigate(redirectPathName);
        }
    };

    useEffect(() => {
        dispatch(setName(""));
    }, [dispatch]);
    return (
        <StyledSearchDesktopComponent $isShowFilter={isShowFilter} width={width}>
            <div className="searchBox">
                <div className="inputBox">
                    <span className="searchIcon">
                        <IconSearch />
                    </span>
                    <span className="searchIconMobile mobile">
                        <IconSearch />
                    </span>
                    <input
                        type="text"
                        value={nameValue}
                        onChange={handleChangeName}
                        onKeyDown={handleEnter}
                        placeholder={
                            width > 767
                                ? "Search your next adventure, stay or tour."
                                : "Search by keyword"
                        }
                    />
                </div>
                <div className="filterBtn" onClick={handleToggleShowFilter}>
                    <button>
                        <IconFilter />
                        <span>Filter</span>
                    </button>
                </div>
                <div className="searchBtn">
                    <StyledButton 
                        color={canSearch ? theme.gradients.button : undefined} 
                        onClick={handleSearch}
                        disabled={!canSearch}
                        $disabled={!canSearch}
                    >
                        Search
                    </StyledButton>
                </div>
            </div>
            <div className="searchBtnMobile mobile">
                <StyledButton
                    $borderRadius={theme.borderRadius.small}
                    color={canSearch ? theme.gradients.button : undefined}
                    onClick={handleSearch}
                    disabled={!canSearch}
                    $disabled={!canSearch}
                >
                    Search
                </StyledButton>
            </div>
            <div className="filterBox">
                <FilterModule
                    onToggleShowFilter={handleToggleShowFilter}
                    isFilterOpen={isShowFilter}
                />
            </div>
        </StyledSearchDesktopComponent>
    );
};
